import { Log } from './log/Log'

export const log = new Log('PDR')
